export const URGENT = {
  HIGH: 1,
  MEDIUM: 2,
  LOW: 3,
};

export const TASK_STATUS = {
  COMPLETED: "completed",
  UNCOMPLETED: "uncompleted",
};
